import { deleteDiscoveryRule as deleteDiscoveryRuleDiagram, rebuildPVDiagram} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { updateGauges } from '@process-advisor/process-miner/api/methods/slicers/updateGauges';

export type DeleteDiscoveryRuleProps = ApiMethodBase & {
    discovery_rule_id: string,
};

export async function deleteDiscoveryRule ({ discovery_rule_id, eventEmitter }: DeleteDiscoveryRuleProps) {
    deleteDiscoveryRuleDiagram(discovery_rule_id);
    updateGauges({ eventEmitter });   
    eventEmitter.emit(Event.setActionBar_DiscoveryRulesSummary);
    eventEmitter.emit(Event.setActionBar_DiscoveryRulesVisualizer);

};

